import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z"
}), 'HorizontalSplit');